import React from 'react'
import Slider from 'react-slick'

const gallery = ({ images }) => {
  const children = images.map((image, index) => (
    <div className="carousel-cell" key={index}>
      <img src={image.source_url} alt={image.title} />
    </div>
  ))

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '10%',
    focusOnSelect: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1650,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <div className="event-media media-gallery">
      <Slider {...settings}>{children}</Slider>
    </div>
  )
}

export default gallery
